import {AxiosInstance} from "axios";

export interface VisitMetrics {
    /** The precision of the computation*/
    precision?: number;
    /** The related pathology */
    pathology: string;
    /** The gender */
    gender: string;
    /** The age.*/
    age: string;
    /** The patient count */
    patients: number;
    /** The average visits */
    visits: number;
    /** The average revenue */
    revenue: number;
}


export default function (apiClient: AxiosInstance) {
    return {
        /**
         * Get the visits statistics from API.
         */
        async visits(): Promise<{
            local: VisitMetrics[]
            global: VisitMetrics[]
        }> {
            return apiClient.get("consumer-visits")
                .then(response => response.data);
        }
    };
}
